export default {
  "content": "<path d=\"M20 8L0 0l2 8-2 8 20-8zM3.81 9h8.3l-9.23 3.69L3.81 9zm8.3-2h-8.3l-.92-3.69L12.11 7z\" fill=\"#005AD9\"/>",
  "attrs": {
    "width": "20",
    "height": "16",
    "viewBox": "0 0 20 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};